/**
 * 将数字转换成为對應单位的字符串，比如10000转为1萬,111111轉為11.11萬
 * @param num 需要轉換的數字
 * @param digist 保留位數
 * @param unit 轉換單位
 * @param needLocalString 是否轉換成千分位,千分位與單位結合衝突
 * @param needToLocalStringLessTenThousand 小於一万时转成是否需要1,000形式
 * @param needToThousand 将数字转换成k的形式,優先級最高
 */
export function formatNumberToUnitString(num, params) {
  var _ref = params || {},
    _ref$digist = _ref.digist,
    digist = _ref$digist === void 0 ? 2 : _ref$digist,
    _ref$needToThousand = _ref.needToThousand,
    needToThousand = _ref$needToThousand === void 0 ? false : _ref$needToThousand,
    _ref$needLocalString = _ref.needLocalString,
    needLocalString = _ref$needLocalString === void 0 ? false : _ref$needLocalString,
    _ref$needToLocalStrin = _ref.needToLocalStringLessTenThousand,
    needToLocalStringLessTenThousand = _ref$needToLocalStrin === void 0 ? false : _ref$needToLocalStrin,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? needToThousand ? "千" : "萬" : _ref$unit;
  if (typeof num !== "number") return num;
  // 转化为1,000,000形式
  if (needLocalString) {
    return Number(num).toLocaleString();
  }
  // 千位机制划分，比如2000 -> 2千
  if (needToThousand) {
    return (num / 1000).toFixed(digist) + unit;
  }
  if (num < 10000) {
    if (needToLocalStringLessTenThousand) {
      return Number(num).toLocaleString();
    }
    return Number(num).toString();
  }
  // 處理後的值
  var current = (num / 10000).toFixed(digist);
  return current + unit;
}